import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { SikoDialogService } from '@siko/shared/utils/siko-dialog.service';
import { TranslatePipe } from '@spartacus/core';
import {
   SikoDialogComponentsModule
} from '@siko/features/shared-components/dialog-components/dialog-components.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'siko-b2b-users-sales-note-dialog',
    templateUrl: './users-sales-note-dialog.component.html',
    styleUrls: ['./users-sales-note-dialog.component.scss'],
    imports: [
       TranslatePipe,
       SikoDialogComponentsModule
    ]
})
export class SikoB2bUsersSalesNoteDialogComponent {

   readonly salesNoteLines = signal<string>('');

   readonly formattedSalesNote = computed(() => {
      return this.salesNoteLines().replace(/\\n/g, '\n');
   });


   dialogService = inject(SikoDialogService);

}
